import styled from 'styled-components';
import { isProd, isTest } from '../../env';
import { Avatar, Dropdown, Layout } from '@arco-design/web-react';
import { ReactNode } from 'react';
import { IconSearch } from '@arco-design/web-react/icon';
const { Header } = Layout;

const StyledAntdHeader = styled(Header)`
  padding: 0 32px;
  height: 50px;
  background-color: ${isProd ? '#001529' : 'rgba(var(--red-9))'};
  display: flex;
  align-items: center;
`;

const HeaderContent = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-weight: 800;
  font-size: 18px;
  box-sizing: border-box;
  overflow: hidden;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MenuIconWrapper = styled.div`
  cursor: pointer;
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    display: block;
    width: 20px;
    height: 2px;
    background: white;
    border-radius: 2px;
  }
`;

export const PageHeader = ({
  userName,
  menu,
  isMenuIconShown,
  onMenuIconClick,
  isSearchIconShown,
  onSearchIconClick,
}: {
  userName?: string;
  menu?: ReactNode;
  isMenuIconShown?: boolean;
  onMenuIconClick?: () => void;
  isSearchIconShown?: boolean;
  onSearchIconClick?: () => void;
}) => {
  return (
    <StyledAntdHeader>
      <HeaderContent>
        <TitleWrapper>
          {isMenuIconShown ? (
            <MenuIconWrapper onClick={onMenuIconClick}>
              <span />
              <span />
              <span />
            </MenuIconWrapper>
          ) : null}
          <div>依凡诗纺织科技有限公司{isTest ? ` For test` : null}</div>
          {isSearchIconShown ? (
            <IconSearch
              strokeWidth={6}
              style={{ cursor: 'pointer' }}
              onClick={onSearchIconClick}
            />
          ) : null}
        </TitleWrapper>
        {userName && menu ? (
          <Dropdown droplist={menu}>
            <Avatar
              size={32}
              style={{
                backgroundColor: 'rgba(var(--orange-5))',
                color: 'rgba(var(--orange-10))',
                verticalAlign: 'middle',
              }}
            >
              {userName[0].toUpperCase()}
            </Avatar>
          </Dropdown>
        ) : null}
      </HeaderContent>
    </StyledAntdHeader>
  );
};
